/**
 * Shared bits for the AD Family Directory hub (Directory / Players / Birthdays).
 * A single debounced, focus-stable search box used by all three tabs so search
 * behaves identically everywhere. (migration_log_0124)
 */
import React, { useState, useEffect } from 'react';
import { Search } from 'lucide-react';

// Debounce a value (default 250ms) — used so typing filters client-side without
// re-rendering storms. Never triggers a network refetch.
export function useDebounced(value, ms = 250) {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}

// Case-insensitive substring match of `q` against any of the given fields.
export function matchesAny(q, fields) {
  const s = (q || '').trim().toLowerCase();
  if (!s) return true;
  return fields.some(v => (v == null ? '' : String(v)).toLowerCase().includes(s));
}

export function SearchBox({ value, onChange, placeholder, isDark, testId, className }) {
  return (
    <div className={`relative ${className || 'flex-1 min-w-[220px]'}`}>
      <Search className={`absolute left-3 top-2.5 h-4 w-4 ${isDark ? 'text-slate-400' : 'text-slate-500'}`} />
      <input
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full rounded-md pl-9 pr-3 py-2 text-sm border ${isDark ? 'bg-slate-800 border-slate-700 text-white placeholder:text-slate-500' : 'bg-white border-slate-300'}`}
        data-testid={testId}
      />
    </div>
  );
}
